// Copyright (c) 2016 Deere & Company

import './status-change-request.scss';
import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import NewStatusInfo from './new-status-info';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import StatusChangeProductInfo from './product-info-view/status-change-product-info';
import StatusChangeRequestForm from '../state/status-change-request-form';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {pageSecurityWrapper} from '../../../shared/components/security-wrapper/page-security-wrapper';

function getMachinePutBack(statusKey) {

    const mapper = {
        DMGD: 'Y',
        EOOS: 'N'
    };

    return mapper[statusKey];

}

function handleCancel() {

    this.actions.goToPreviousView();

}

function handleSave() {

    this.actions.createStatusChangeRequest();

}

function handleUpdate() {

    this.actions.updateStatusChangeRequest();

}

function handleItemChange(name, value) {

    this.actions.updateStatusChangeRequestObject(name, value);

    if (name === 'country') {

        this.actions.fetchStatesInCountry(value.key);

    }

    this.actions.updateStatusChangeRequestForm();

    if (value.key === 'DMGD' || value.key === 'EOOS') {

        this.actions.updateSelectedMachinePutBack(getMachinePutBack(value.key));

    }

}

function handleFileDelete(file) {

    this.actions.deleteFileFromStatusChangeRequest(file);

}

function handleFileUploadSuccess(file) {

    this.actions.updateStatusChangeRequestObject('addFile', file);

}

function handleSelectedMachinePutBack(radioListItem) {

    this.actions.updateSelectedMachinePutBack(radioListItem.key);

}

let matchineStatusChange;

class StatusChangeRequest extends Component {

    componentWillMount() {

        const statusChangeId = this.props.queryParams && this.props.queryParams.statusChangeId;

        matchineStatusChange = statusChangeId ? this.props.machineStatusUpdates.find(update => update.id === statusChangeId) : null;

        if (matchineStatusChange) {

            this.props.actions.setStatusChangeRequestState(matchineStatusChange);

        }
        this.props.actions.updateProduct(this.props.routeParams.pin);
        this.props.actions.fetchCountries();
        this.props.actions.fetchStatesInCountry('US');
        this.props.actions.fetchPrimaryProductStatuses();

    }

    componentWillUnmount() {

        this.props.actions.resetStatusChangeRequestState();

    }

    render() {

        return (
            <div className='status-change-request'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <header>
                    <h2 className='product-pin'>
                        <FormattedMessage
                            id='CHANGE_STATUS_FOR'
                            values={{
                                pin: this.props.product.pin
                            }}
                        />
                    </h2>
                    <section className='button-group'>
                        <button
                            className='cancel'
                            onClick={this.props::handleCancel}
                        >
                            <FormattedMessage id='CANCEL'/>
                        </button>
                        <button
                            className='save'
                            disabled={!this.props.statusChangeRequestForm.isValid}
                            onClick={matchineStatusChange ? this.props::handleUpdate : this.props::handleSave}
                        >
                            {matchineStatusChange ? <FormattedMessage id='UPDATE'/> : <FormattedMessage id='SAVE'/>}
                        </button>
                    </section>
                </header>
                <main>
                    <StatusChangeProductInfo
                        product={this.props.product}
                    />
                    <NewStatusInfo
                        countries={this.props.countries}
                        files={this.props.statusChangeRequest.file}
                        handleFileDelete={this.props::handleFileDelete}
                        handleFileUploadSuccess={this.props::handleFileUploadSuccess}
                        isMatchineStatusChange={Boolean(matchineStatusChange)}
                        onItemChange={this.props::handleItemChange}
                        onSelectedMachinePutBack={this.props::handleSelectedMachinePutBack}
                        product={this.props.product}
                        statesInCountry={this.props.statesInCountry}
                        statusChangeRequest={this.props.statusChangeRequest}
                        statuses={this.props.primaryProductStatuses}
                    />
                </main>
            </div>
        );

    }

}

StatusChangeRequest.displayName = 'StatusChangeRequest';
StatusChangeRequest.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    countries: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    machineStatusUpdates: PropTypes.arrayOf(PropTypes.instanceOf(StatusChange)).isRequired,
    primaryProductStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    queryParams: PropTypes.object,
    routeParams: PropTypes.object.isRequired,
    statesInCountry: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired,
    statusChangeRequestForm: PropTypes.instanceOf(StatusChangeRequestForm).isRequired
};

export default pageSecurityWrapper('PRT', 'PRT_STATUS_CHANGE')(StatusChangeRequest);



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/status-change-request.js